import BaseModel from '../core/BaseModel'
import moment from "moment";

export default class WarrantyRepairModel extends BaseModel {
    constructor() {
        super({
                name: "warranty_repair",
                tableName: 'core_warranty_repair'
            },
            {
                id: {
                    name: 'id',
                    type: "String",
                    label: 'ID',
                    primaryKey: true,
                    display: false
                },
                code: {
                    name: 'code',
                    type: "String",
                    label: 'Mã dịch vụ',
                    width: 15,
                    sortable: true,
                    filter: {type: 'input', match: 'custom', placeHolder: 'Nhập mã DV'}
                },
                receive_user_info: {
                    name: 'receive_user_info',
                    type: "String",
                    label: 'Khách hàng',
                    sortable: false,
                    width: 15,
                    filter: { type: 'input',  match: 'custom',placeHolder: 'Nhập tên hoặc SĐT'},
                    computed: (data) => {
                        var receive_user_info = "";
                        if (data.obj_receive_user){
                            if (data.receive_sender == 0) {
                                receive_user_info += (data.obj_receive_user.obj_customer_profile) ? data.obj_receive_user.obj_customer_profile.phone_number.replace('+84', '0')+" - ":'';
                                receive_user_info += (data.obj_receive_user.obj_customer_profile) ? data.obj_receive_user.obj_customer_profile.full_name:'';
                            }else if (data.receive_sender == 1) {
                                receive_user_info += (data.obj_receive_user) ? data.obj_receive_user.phone_number.replace('+84', '0')+" - ":'';
                                receive_user_info += (data.obj_receive_user) ? data.obj_receive_user.full_name:'';
                            }

                        }
                        data.receive_user_info = receive_user_info;
                    }
                },
                list_serial_number_info: {
                    name: 'list_serial_number_info',
                    type: "String",
                    label: 'Serial number',
                    sortable: false,
                    width: 15,
                    filter: { type: 'input',  match: 'custom'},
                    computed: (data) => {
                        var list_serial_number = (data.list_serial_number) ? data.list_serial_number.trim():"";
                        var str_serial = list_serial_number;//bỏ ký tự đầu và cuối
                        str_serial = str_serial.replaceAll('#', '');
                        str_serial = str_serial.replaceAll(',', '<br>');
                        data.list_serial_number_info = str_serial;
                    }
                },
                receive_day_reception: {
                    name: 'receive_day_reception',
                    type: "Date",
                    label: 'Ngày tiếp nhận',
                    width: 15,
                    sortable: true,
                    filter: { type: 'DateRange', match: 'custom'}
                },
                /*delivery_return_appointment_day: {
                    name: 'delivery_return_appointment_day',
                    type: "Date",
                    label: 'Ngày hẹn trả',
                    width: 15,
                    sortable: true,
                    filter: { type: 'DateRange', match: 'custom'}
                },*/
                delivery_return_appointment_day_info: {
                    name: 'delivery_return_appointment_day_info',
                    type: "Date",
                    label: 'Ngày hẹn trả',
                    width: 15,
                    sortable: true,
                    filter: { type: 'DateRange', match: 'custom'},
                    computed: (data) => {
                        var timezone = 'Asia/Bangkok';
                        var date_check =  moment.tz(data.delivery_return_appointment_day, timezone).format('YYYYMMDD');
                        var date_current =  moment.tz(timezone).format('YYYYMMDD');

                        if (date_current > date_check){
                            data.customClass = [{
                                column:"delivery_return_appointment_day_info",
                                class:"late_delivery_return_appointment_day"
                            }];
                        }
                        data.delivery_return_appointment_day_info = (data.delivery_return_appointment_day) ? data.delivery_return_appointment_day : ''
                    }
                },
                organization_creator_info: {
                    name: 'organization_creator_info',
                    type: "String",
                    label: 'Đơn vị thực hiện',
                    sortable: true,
                    width: 15,
                    filter: { type: 'input',  match: 'custom',placeHolder: 'Nhập đơn vị'},
                    computed: (data) => {
                        var organization_creator_info = "";
                        if (data.obj_creator_organization){
                                    organization_creator_info = (data.obj_creator_organization.name) ? data.obj_creator_organization.name:'';
                        }
                        /*if (data.obj_creator){
                            if (data.obj_creator.organization_account){
                                if (data.obj_creator.organization_account.organization){
                                    organization_creator_info = (data.obj_creator.organization_account.organization.name) ? data.obj_creator.organization_account.organization.name:'';
                                }
                            }
                        }*/
                        data.organization_creator_info = organization_creator_info;
                    }
                },
                creator_info: {
                    name: 'creator_info',
                    type: "String",
                    label: 'Người cập nhật',
                    sortable: true,
                    width: 15,
                    filter: { type: 'input',  match: 'custom',placeHolder: 'Nhập tên nhân viên'},
                    computed: (data) => {
                        var creator_info = "";
                        if (data.obj_modifier){
                            creator_info = (data.obj_modifier.full_name) ? data.obj_modifier.full_name:'';
                        }
                        data.creator_info = creator_info;
                    }
                },
                process_status: {
                    name: 'process_status',
                    label: 'Tiến độ thực hiện',
                    type: "Selection",
                    dataType: 'Label',
                    class: 'center disabled-opacity',
                    width: 15,
                    disabled: true,
                    sortable: true,
                    options: [{ value: 0, label: 'Gửi yêu cầu', style: 'color: #CC0000; font-weight: 500;'}, { value: 1, label: 'Chờ tiếp nhận', style: 'color: #990099; font-weight: 500;'}, { value: 2, label: 'Chờ thực hiện', style: 'color: #0066FF; font-weight: 500;'}, { value: 3, label: 'Chờ giao trả', style: 'color: #FF6600;font-weight: 500;'}, { value: 4, label: 'Hoàn thành', style: 'color: #009900;font-weight: 500;'}],
                    filter: {type: 'select', display: false, optionLabel: 'label', optionKey: 'value', match: 'equals'},
                },
                fied_detail: {
                    refs: 'note_delivery delivery_return_appointment_day list_serial_number receive_sender obj_receive_user { full_name phone_number obj_customer_profile { id full_name phone_number } } obj_creator { id full_name organization_account { organization { name id } } } obj_modifier { id full_name organization_account { organization { name id } } }  obj_creator_organization{ name id }',
                    display: false
                },
            },)
    }
}